export default [
    {
        path: "/",
        name: "home",
        component: () => import("../views/Home/Index.vue"),
    },
    // 登录
    {
        path: "/login",
        name: "login",
        component: () => import("../views/Home/login.vue"),
        meta: {
            isLogin: true,
        },
    },
    {
        path: "/word",
        component: () => import("../views/userCenter/word.vue"),
    },
    {
        path: "/word2",
        name: 'word',
        component: () => import("../views/userCenter/word2.vue"),
        meta: {
            isWord: true,
        },
    },
    {
        path: "/articleDetail",
        component: () => import("../views/common/articleDetail.vue"),
    },
    // 首页跳转功能
    // 期刊分析
    {
        path: "/journalList",
        component: () => import("../views/smartSpace/journal/list.vue"),
    },
    {
        path: "/journalDetail/:id",
        name: "journalDetail-id",
        component: () => import("../views/smartSpace/journal/detail.vue"),
    },
    // 认证
    // {
    //   path: '/user/authentication',
    //   name: 'authentication',
    //   component: () => import('../views/userCenter/authentication.vue')
    // },
    // 实名认证
    {
        path: "/user/certification",
        name: "certification",
        component: () => import("../views/userCenter/certification.vue"),
    },
    // 绑定学者
    {
        path: "/user/authorBind",
        name: "authorBind",
        component: () => import("../views/userCenter/authorBind.vue"),
    },
    // 课题申报
    {
        path: "/application",
        name: "/application",
        component: () => import("../views/application/index.vue"),
    },
    {
        path: "/application/list",
        name: "/application/list",
        component: () => import("../views/application/list.vue"),
    },
    {
        path: "/application/detail/",
        name: "/application/detail/",
        component: () => import("../views/application/detail.vue"),
    },
    {
        path: "/application/new/:id",
        name: "/application/new",
        component: () => import("../views/application/new.vue"),
    },
    // 学者信息页
    {
        path: "/authorInfo",
        name: "authorInfo",
        component: () => import("../views/common/authorInfo.vue"),
    },
    {
        path: "/authorInfoCase",
        name: "authorInfoCase",
        component: () => import("../views/common/authorInfoCase.vue"),
    },
    {
        path: "/schoolmagazinelist",
        component: () => import("../views/schoolmagazine/list.vue"),
    },
    {
        path: "/schoolmagazineDetail/:id",
        component: () => import("../views/schoolmagazine/detail.vue"),
    },
    {
        path: "/schoolmagazineread/:id",
        component: () => import("../views/schoolmagazine/pdfread.vue"),
    },
    {
        path: "/magazineReader",
        component: () => import("../views/schoolmagazine/magazinereader.vue"),
    },
    //专家辅导
    {
        path: "/specialist",
        component: () => import("../views/specialist/index.vue"),
    },
    {
        path: "/specialist/detail/:id",
        name: "specialistId",
        component: () => import("../views/specialist/detail.vue"),
    },
    {
        path: "/specialist/application",
        name: "specialist",
        component: () => import("../views/specialist/application.vue"),
    },

    {
        path: "/school-info/register",
        name: "SchoolInfoRegister",
        component: () => import("../views/school-info/register.vue"),
    },
    {
        path: "/school-area",
        name: "SchoolArea",
        component: () => import("../views/school-area/index.vue"),
    },
    //机构绑定
    {
        path: "/regBind/:json",
        name: "organRegBind",
        component: () => import("../views/Home/regBind.vue"),
    },
    // 用户注销
    {
        path: "/user/logOff",
        name: "logOff",
        component: () => import("../views/userCenter/logOff.vue"),
    },
    {
        path: "/meeting",
        name: "meeting",
        component: () => import("../views/meeting/index.vue"),
    },
    {
        path: "/meeting/:id",
        name: "meetingDetail",
        component: () => import("../views/meeting/detail.vue"),
    },
    {
        path: "/wenYuan",
        name: "wenYuan",
        component: () => import("../views/wenYuan/wenYuan.vue"),
    },
    // 教研成果
    {
        path: "/achievement",
        name: "achievement",
        component: () => import("../views/achievement/index.vue"),
    },
    {
        path: "/paperTest",
        name: "paperTest",
        component: () => import("../views/paperTest/index.vue"),
    },
    {
        path: "/schoolmagazine",
        name: "schoolmagazine",
        component: () => import("../views/schoolmagazine/index.vue"),
    },
]